// @flow
import type { SetNewPreferenceValue } from "@tvg/shared-actions/UserActions";
import type {
  OnboardingRoute,
  TutorialListFromService,
  Tutorial
} from "@tvg/types/OnBoarding";

type SetOnboardingRoutes = {
  type: "ONBOARDING_SET_TUTORIAL_ROUTES",
  payload: {
    tutorials: OnboardingRoute[]
  }
};

type OpenOnboardingPrompt = {
  type: "ONBOARDING_OPEN_PROMPT",
  payload: {
    tutorial: Tutorial | TutorialListFromService
  }
};

type CloseOnboardingPrompt = {
  type: "ONBOARDING_CLOSE_PROMPT"
};

type OpenOnboardingTutorial = {
  type: "ONBOARDING_OPEN_TUTORIAL",
  payload: {
    tutorial: Tutorial | TutorialListFromService,
    redirect: boolean | null
  }
};

type CloseOnboardingTutorial = {
  type: "ONBOARDING_CLOSE_TUTORIAL"
};

export type Actions =
  | SetOnboardingRoutes
  | OpenOnboardingPrompt
  | CloseOnboardingPrompt
  | OpenOnboardingTutorial
  | CloseOnboardingTutorial
  | SetNewPreferenceValue;

export const setOnboardingTutorials = (
  tutorials: OnboardingRoute[]
): SetOnboardingRoutes => ({
  type: "ONBOARDING_SET_TUTORIAL_ROUTES",
  payload: { tutorials }
});

export const openPrompt = (tutorial: Tutorial): OpenOnboardingPrompt => ({
  type: "ONBOARDING_OPEN_PROMPT",
  payload: { tutorial }
});

export const closePrompt = (): CloseOnboardingPrompt => ({
  type: "ONBOARDING_CLOSE_PROMPT"
});

export const openTutorial = (
  tutorial: TutorialListFromService,
  redirect: boolean
): OpenOnboardingTutorial => ({
  type: "ONBOARDING_OPEN_TUTORIAL",
  payload: { tutorial, redirect }
});

export const closeTutorial = (): CloseOnboardingTutorial => ({
  type: "ONBOARDING_CLOSE_TUTORIAL"
});
